import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import { ContentWrapper } from '@eti/components';
import { Columns, Stack, vars } from '@etg/wings';
import Skeleton from '../../../../../common/components/Skeleton';
import LoadingBar from '../loading-bar/LoadingBar';
import FiltersSkeleton from './FiltersSkeleton';
import FlightResultSkeleton from './FlightResultSkeleton';
import SortingSkeleton from './SortingSkeleton';

export const NUMBER_OF_RESULTS = 5;

const resultsStyles = css`
  width: 100%;
`;

export const Results = ({ children }: { children: ReactNode }) => (
  <div className={resultsStyles}>{children}</div>
);

const resultWrapperStyles = css`
  background: ${etiColors.white};
  border-radius: ${vars.card.borderRadius};
  margin-block-start: 16px;

  &:first-child {
    margin-block-start: 0;
  }
`;

export const ResultWrapper = ({ className, ...rest }: ComponentPropsWithoutRef<'div'>) => (
  <div className={cx(resultWrapperStyles, className)} {...rest} />
);

const filtersAndResultStyles = css`
  display: flex;
  gap: 24px;

  @media ${mediaQueries.medium.down} {
    padding: 0;
  }
`;

const sortingResultWrapperStyles = css`
  flex: 1;
  padding: 0 12px;
`;

const filterResultWrapperStyles = css`
  width: 100%;
`;

const ResultSkeleton = () => {
  return (
    <>
      <LoadingBar />
      <Skeleton.Section data-testid="resultPage-skeleton">
        <Skeleton.Wrapper>
          <ContentWrapper className={filtersAndResultStyles}>
            <Stack className={filterResultWrapperStyles}>
              <Columns>
                <FiltersSkeleton />
                <Stack className={sortingResultWrapperStyles} spacing={8}>
                  <SortingSkeleton />
                  <Results>
                    {[...Array(NUMBER_OF_RESULTS)].map((_, index) => (
                      <ResultWrapper key={index}>
                        <FlightResultSkeleton />
                      </ResultWrapper>
                    ))}
                  </Results>
                </Stack>
              </Columns>
            </Stack>
          </ContentWrapper>
        </Skeleton.Wrapper>
      </Skeleton.Section>
    </>
  );
};

export default ResultSkeleton;
